import { gql, useQuery, useLazyQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { Server } from "../../../apollo/types";
import { requiredAgreementsEnabled } from "../../../statsig/gates";
import { useFeatureGate } from "@statsig/react-bindings";

export type ClientRequiresAuthedIntroRoomQuery = {
  clientRequiresAuthedIntroRoom: {
    requireAuth: boolean;
    clientUserShortId: string | null;
  };
};

export type ClientRequiresAuthedIntroRoomVariables = {
  patientShortId: string;
};

export const CLIENT_REQUIRES_AUTHED_INTRO_ROOM = gql`
  query ClientRequiresAuthedIntroRoom($patientShortId: String!) {
    clientRequiresAuthedIntroRoom(patientShortId: $patientShortId) {
      requireAuth
      clientUserShortId
    }
  }
`;

export function useGetClientRequiresAuthedIntroRoom() {
  const { patientShortId } = useParams();
  const { value: isRequiredAgreementsEnabled } = useFeatureGate(
    requiredAgreementsEnabled,
  );

  return useQuery<
    ClientRequiresAuthedIntroRoomQuery,
    ClientRequiresAuthedIntroRoomVariables
  >(CLIENT_REQUIRES_AUTHED_INTRO_ROOM, {
    variables: { patientShortId: patientShortId as string },
    skip: !patientShortId || !isRequiredAgreementsEnabled,
    context: { server: Server.MONOLITH, skipAuth: true },
  });
}

export function useLazyClientRequiresAuthedIntroRoom() {
  return useLazyQuery<
    ClientRequiresAuthedIntroRoomQuery,
    ClientRequiresAuthedIntroRoomVariables
  >(CLIENT_REQUIRES_AUTHED_INTRO_ROOM, {
    context: { server: Server.MONOLITH, skipAuth: true },
    fetchPolicy: "network-only",
  });
}
